import React, { useState } from "react";
import "./featurePreview.css";
import { useDispatch, useSelector } from "react-redux";
import { updateReportFeatures } from "../../../Features/reportFeatures";
import { updateReportInfo } from "../../../reducer/reportInfo.reducer";

export default function FeaturePreview({
  setShowFeatureSelection,
  disclaimerEmpty,
}) {
  const dispatch = useDispatch();
  let featureOptions = useSelector((state) => state.reportFeatures);
  const reportInfo = useSelector((state) => state.reportInfo);
  const [checkWord, setCheckWord] = useState(false);
  let selectAll = true;

  featureOptions.forEach((item) => {
    if (!item[2]) {
      selectAll = false;
    }
  });

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        dispatch(
          updateReportInfo({ field: "companyLogo", value: reader.result })
        );
      };
    }
  };

  const handleCheckAll = (e) => {
    featureOptions = featureOptions.map((item) => {
      return item[3] || item[0] === "Product Data Sheets"
        ? [item[0], item[1], e.target.checked, item[3]]
        : [item[0], item[1], e.target.checked];
    });

    dispatch(updateReportFeatures(featureOptions));

    let checkboxes = document.getElementsByClassName("check-boxes");
    if (e.target.checked) {
      for (let i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = true;
      }
    } else {
      for (let i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = false;
      }
    }
  };

  const handleCheckOne = (e) => {
    featureOptions = featureOptions.map((item, index) => {
      if (index === Number(e.target.id))
        return item[3] || item[0] === "Product Data Sheets"
          ? [item[0], item[1], e.target.checked, item[3]]
          : [item[0], item[1], e.target.checked];
      return item[3] || item[0] === "Product Data Sheets"
        ? [item[0], item[1], item[2], item[3]]
        : [item[0], item[1], item[2]];
    });
    dispatch(updateReportFeatures(featureOptions));

    let selAll = document.getElementById("sel-all");
    if (!e.target.checked) {
      selAll.checked = false;
    }
  };

  const handleSubCheck = (e, subIndex, index) => {
    featureOptions = featureOptions.map((item, idx) => {
      if (idx === index) {
        const updatedSubArray = item[3].map((sub, i) => {
          if (i === subIndex) {
            return [sub[0], e.target.checked];
          }
          return sub;
        });
        return [item[0], item[1], item[2], updatedSubArray];
      } else {
        return item;
      }
    });

    dispatch(updateReportFeatures(featureOptions));

    let selAll = document.getElementById("sel-all");
    if (!e.target.checked) {
      selAll.checked = false;
    }
  };

  const handleUpdateDisclaimer = (e) => {
    const { name, value } = e.target;
    if (name === "disclaimerTermsCondition") {
      const wordCount = value.length;
      if (wordCount <= 1800) {
        dispatch(updateReportInfo({ field: name, value }));
        setCheckWord(false);
      } else {
        setCheckWord(true);
      }
    } else {
      dispatch(updateReportInfo({ field: name, value }));
    }
  };

  return (
    <>
      <div>
        <img
          src="./images/assets/close.png"
          className="close"
          onClick={() => setShowFeatureSelection(false)}
          alt="close icon"
        />
        <div className="inputs-cont">
          <div className="inputs">
            <h3 className="heading">Company Name</h3>
            <div className="fileBox">
              <input
                type="text"
                className="inputField"
                name="companyName"
                value={reportInfo.companyName}
                onChange={(e) => handleUpdateDisclaimer(e)}
              />
            </div>
          </div>
          <div className="inputs">
            <h3 className="heading">Add Logo</h3>
            <div
              className="logo"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="fileBox">
                <input
                  id="img-upload"
                  placeholder="test"
                  type="file"
                  name="img"
                  aria-labelledby="Choose Logo"
                  accept="image/*"
                  onChange={(e) => handleFileUpload(e)}
                />
                <span>
                  {"*Upload png, jgep, jpg, svg file with less than 1MB."}
                </span>
              </div>

              <img
                src={reportInfo?.companyLogo}
                alt="companyLogo"
                style={{ width: "115px", maxHeight: "55px" }}
              />
            </div>
          </div>
        </div>
        <div className="optionMainBox">
          <h3 className="heading">Feature Selection</h3>
          <h3 className="heading">Disclaimer Info</h3>
        </div>
        <div className="optionMainBox">
          <div className="select-options">
            <div className="select-option">
              <input
                id="sel-all"
                onChange={(e) => handleCheckAll(e)}
                type="checkbox"
                defaultChecked={selectAll}
              />
              <label htmlFor="sel-all">All Content</label>
            </div>
            {featureOptions.map((item, index) => {
              return (
                <React.Fragment>
                  <div key={index} className="select-option">
                    <input
                      id={index}
                      onChange={(e) => handleCheckOne(e)}
                      type="checkbox"
                      className="check-boxes"
                      defaultChecked={featureOptions[index][2]}
                    />
                    <label htmlFor={index}>{item[0]}</label>
                    {item[1] && (
                      <span>
                        <img
                          style={{ margin: "0px 0px 12px 1px", width: "11px" }}
                          src="./images/assets/premium.svg"
                          alt="premium icon"
                        />
                      </span>
                    )}
                  </div>
                  {Array.isArray(item[3]) &&
                    item[2] &&
                    item[3].map((subItem, subIndex) => {
                      return (
                        <div key={subIndex} className="subOption">
                          <input
                            id={subIndex}
                            onChange={(e) => handleSubCheck(e, subIndex, index)}
                            type="checkbox"
                            className="check-boxes"
                            defaultChecked={subItem[1]}
                          />
                          <label htmlFor={subIndex}>{subItem[0]}</label>
                        </div>
                      );
                    })}
                </React.Fragment>
              );
            })}
          </div>
          <div className="disclaimerInfo">
            <div className="inputs">
              <label>Disclaimer Terms & Condition</label>
              <textarea
                rows={4}
                name="disclaimerTermsCondition"
                placeholder="Enter the Disclaimer Terms & Condition"
                value={reportInfo.disclaimerTermsCondition}
                onChange={(e) => handleUpdateDisclaimer(e)}
              ></textarea>
            </div>
            {disclaimerEmpty && !reportInfo.disclaimerTermsCondition && (
              <span>This field is mandatory</span>
            )}
            {checkWord && (
              <span>Disclaimer must be 1800 characters or less.</span>
            )}
            <div className="inputs">
              <label>Company Address</label>
              <input
                type="text"
                placeholder="Enter the company address"
                name="companyAddress"
                value={reportInfo.companyAddress}
                onChange={(e) => handleUpdateDisclaimer(e)}
              ></input>
            </div>
            {disclaimerEmpty && !reportInfo.companyAddress && (
              <span>This field is mandatory</span>
            )}
            <div className="inputs">
              <label>Company Phone No</label>
              <input
                type="number"
                name="companyPhoneNo"
                placeholder="Enter the company phone no"
                value={reportInfo.companyPhoneNo}
                onChange={(e) => handleUpdateDisclaimer(e)}
              ></input>
            </div>
            {disclaimerEmpty && !reportInfo.companyPhoneNo && (
              <span>This field is mandatory</span>
            )}
            <div className="inputs">
              <label>Company Email</label>
              <input
                type="text"
                name="companyEmail"
                placeholder="Enter the company email"
                value={reportInfo.companyEmail}
                onChange={(e) => handleUpdateDisclaimer(e)}
              ></input>
            </div>
            {disclaimerEmpty && !reportInfo.companyEmail && (
              <span>This field is mandatory</span>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
